import React from 'react';
import './index.css';
import './number.scss';
const NumberInfo = ({
  theme,
  title,
  categoryTitle,
  categoryTitle1,
  categoryTitle2,
  totalItems,
  totalQuantity,
  totalCbm,
  status,
  numberTitle,
  iconImage,
  suffix,
  gap,
  ...rest
}) => (
  <div>
    <div>
      {title && (
        <div
          className={numberTitle}
          title={typeof title === 'string' ? title : ''}
        >
          <div>{title}</div>
          <div>
            {' '}
            <img src={iconImage} alt='{iconImage}' />
          </div>
        </div>
      )}
      <div className='numberValue'>
        <div>
          <span className='suffix'>{typeof totalItems === 'number' && totalItems != null ? totalItems.toLocaleString() : (totalItems ?? '')}</span>
          <div className='title'>{categoryTitle}</div>
        </div>
        <div>
          <span className='suffix'>{typeof totalQuantity === 'number' && totalQuantity != null ? totalQuantity.toLocaleString('en-US', {minimumFractionDigits:0, maximumFractionDigits:0}) : (totalQuantity ?? '')}</span>
          <div className='title'>{categoryTitle1}</div>
        </div>
        <div>
          <span className='suffix'>{typeof totalCbm === 'number' && totalCbm != null ? totalCbm.toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2}) : (totalCbm ?? '')}</span>
          <div className='title'>{categoryTitle2}</div>
        </div>
      </div>
    </div>
  </div>
);

export default NumberInfo;
